/** Trạng thái che học liệu (plan 2026-10-03) — dùng chung giữa provider và các lớp phủ. */
import { createContext, useContext } from "react";

export type ShieldReason = "blur" | "hidden" | "screenshot" | "print";

export interface ShieldState {
  hidden: boolean;
  reason: ShieldReason | null;
  /** Mở lại (chỉ khi cửa sổ đang có focus). */
  reveal: () => void;
}

export const ContentShieldContext = createContext<ShieldState | null>(null);

/** null = tính năng che màn hình tắt / ngoài trang học bài. */
export const useContentShield = () => useContext(ContentShieldContext);
